export default {"src":"/_next/static/image/public/images/placeholder_payment_card.2ce32007016d684243caa3cd42f4099b.svg","height":183,"width":180};